import React from "react";
import { StudentFormProp } from "../../../../../../types/Forms";
import { Col, Input, Label, Row } from "reactstrap";
import { ConfirmPassword, Email, Name, Password } from "../../../../../../constants";

const BasicInfoForm:React.FC<StudentFormProp>=({ formData, updateFormData, register, errors })=> {
  return (
    <Row className="g-3">
      <Col sm="6">
        <Label>{Name}</Label>
        <Input {...register("name", { required: "Name is required" })} value={formData.name} type="text" placeholder="Enter your name" onChange={updateFormData} />
          {errors.name && <span className="text-danger">{errors.name.message}</span>}
      </Col>
      <Col sm="6">
        <Label>{Email}<span className="txt-danger">*</span></Label>
        <Input {...register("email", { required: "Email is required" })} value={formData.email} type="email" placeholder="johan@gmail.com" onChange={updateFormData} />
        {errors.email && <span className="text-danger">{errors.email.message}</span>}
      </Col>
      <Col xs="12">
        <Col sm="12">
          <Label>{Password}<span className="txt-danger">*</span></Label>
        </Col>
        <Input {...register("password", { required: "Password is required" })} value={formData.password} type="password" placeholder="Enter password" onChange={updateFormData} autoComplete="off" />
        {errors.password && <span className="text-danger">{errors.password.message}</span>}
      </Col>
      <Col xs="12">
        <Col sm="12">
          <Label>{ConfirmPassword}<span className="txt-danger">*</span></Label>
        </Col>
        <Input {...register("confirmPassWord", { required: "Confirm password is required" })} value={formData.confirmPassWord} type="password" placeholder="Enter confirm password" autoComplete="off" onChange={updateFormData} />
        {errors.confirmPassWord && <span className="text-danger">{errors.confirmPassWord.message}</span>}
      </Col>
    </Row>
  );
}
export default BasicInfoForm